import { BodyCreateSystemChatChatSystemChatCreatePost } from "@virtualprogaming/js-public-sdk";
import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "../useChatApi";

export function useChatCreateSystemConversation(
  options?: UseMutationOptions<
    AxiosResponse,
    unknown,
    [
      string,
      string,
      string,
      string | undefined,
      BodyCreateSystemChatChatSystemChatCreatePost
    ]
  >
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((vars) => api.createSystemChat(...vars), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversations"]);
    },
    ...rest,
  });
}
